import React from "react";
import { Textarea } from "@/components/ui/textarea";

export default function TextareaBlock({ block, value = "", onChange }) {
  return (
    <div className="rounded-xl border border-border bg-card/60 p-4 sm:p-5 print-avoid-break">
      <label className="mb-2 block text-sm font-semibold uppercase tracking-wider text-foreground">{block.label}</label>
      <Textarea
        data-testid={`textarea-${block.key}`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="min-h-[120px] bg-secondary/40"
        placeholder="Type notes here…"
      />
    </div>
  );
}
